"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorFallback = exports.genericError = void 0;
const colors_1 = require("./colors");
exports.genericError = {
    headingFont: 'Roboto-Regular',
    headingColor: colors_1.colors.light[900],
    messageColor: colors_1.colors.dark[400],
};
exports.errorFallback = {
    genericError: exports.genericError,
};
